import { render, staticRenderFns } from "./admincp-menu.vue?vue&type=template&id=1f312876&"
import script from "./admincp-menu.vue?vue&type=script&lang=ts&"
export * from "./admincp-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports